import React from 'react'
import {getGlobalEnv} from '../../helpers/coreUtil'
import { loadHubspotChat } from '../../helpers/util'
import ResponsiveImg from '../common/ResponsiveImg'
import Word from '../common/Word'
import {useWebp} from '../hocs/hooks'
import styles from './Home.scss'
import CvArea from './home/CvArea'
import HomeStatement from './home/HomeStatement'
import HostVoice from './home/HostVoice'
import Merit from './home/Merit'
import QA from './home/QA'
import SharedStations from './home/SharedStations'
import ShareStatus from './home/ShareStatus'
import Support from './home/Support'
import Usage from './home/Usage'
import WhatIsCarstay from './home/WhatIsCarstay'
import HostTop from '../../assets/imgs/host/host-cover-top.png'
import HostTopDimension from '../../assets/imgs/host/host-cover-top.png?size'
import HostTopSp from '../../assets/imgs/host/host-cover-top-sp.png'
import HostTopSpDimension from '../../assets/imgs/host/host-cover-top-sp.png?size'
import { IRouteComponentProps } from '../containers/DataResolver'
import { IStation } from '../../../models/Station'

const Home = ({resolvedData: {stations}}: IRouteComponentProps<{stations: ReadonlyArray<IStation>}>) => {

  const webp = useWebp()
  const hostDocUrl = 'https://share.hsforms.com/18VowgkqoRXOUrVfQxwM4iA3jx43'

  loadHubspotChat(getGlobalEnv('HUBSPOT_ID'))

  return <>
    <div className={['w-100 text-white', webp && styles.webp].join(' ')}>
      <div className={['position-relative'].join(' ')}>
        <div className={styles.hidden}>
          <ResponsiveImg
           url={HostTop}
           caption="HostTop"
           srcSet={HostTop}
           dimension={HostTopDimension}
          />
        </div>
        <div className={styles.show}>
          <ResponsiveImg
            url={HostTopSp}
            caption="HostTopSP"
            dimension={HostTopSpDimension}
          />
        </div>
        <div className={styles.center}>
          <div className={styles.colorOverlay}>
            <div className={styles.content}>
              <h1 className={styles.title}>
                <Word>空き地・駐車場を旅行者に貸して</Word><br/>
                <Word>副収入を得ませんか？</Word>
              </h1>
              <div className={styles.mb32} />
              <a href={hostDocUrl} className={['btn btn-primary', styles.button, styles.fs15].join(' ')}>
                資料ダウンロード
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <WhatIsCarstay />
    <Merit />
    <ShareStatus />
    <CvArea />
    <HostVoice />
    <Support />
    <Usage />
    <CvArea />
    <QA />
    <CvArea />
    <SharedStations stations={stations} />
    <HomeStatement />
  </>
}
Home.displayName = 'Home'
export default Home
